import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export function authenticationGuard(): CanActivateFn {
  return async () => {
    const authService: AuthService = inject(AuthService);
    const router = inject(Router);

    const isSuperAdmin = await authService.isSuperAdmin();

    return isSuperAdmin ? true : router.createUrlTree(['/login']);
  };
}
